import Menu from "../../components/Menu"
import RoundyContainer from "../../components/RoundyContainer"
import { VehicleChangeContextComp } from "../../components/ChangeRequest_VehicleChangeComp/VehicleChangeContext"
import VehicleDA_Main from "../../components/ChangeRequest_VehicleChangeComp/2_DriverAssignment/VehicleDA_Main"
import VehicleProgressBar from "../../components/ChangeRequest_VehicleChangeComp/VehicleProgressBar"
import { useEffect } from "react"

const VehiclesDriverAssignment = (props) => {
    const { userData } = props.user

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])
    return (
        <>
        <VehicleChangeContextComp>
            <Menu Title={"VEHICLE CHANGE"} FirstName={userData.firstName} userData={userData} />
            <VehicleProgressBar screen={"Driver Assignment"} />
            <RoundyContainer Content={VehicleDA_Main} NoRoundy
                params={{
                    storedData: { ...props.storedData },
                    setStoredData: props.setStoredData
                }}
            />
        </VehicleChangeContextComp>
        </>
    )
}

export default VehiclesDriverAssignment